<script setup lang="ts">
import { loadConfig } from './services/ConfigService';

const loading = ref(true)

onBeforeMount(async () => {
  await loadConfig()
  loading.value = false
})
</script>

<template>
  <n-flex vertical align="center" size="large" class="py-12 px-6">
    <header class="text-neutral-500">
      Commercial Data Insights
    </header>

    <div v-if="!loading" class="pt-2 w-full">
      <n-modal-provider>
        <n-notification-provider>
          <n-dialog-provider>
            <n-message-provider>
              <RouterView />
            </n-message-provider>
          </n-dialog-provider>
        </n-notification-provider>
      </n-modal-provider>
    </div>
  </n-flex>
</template>